import { createHandler } from '@mews/std';
import { GO, GO_BACK, GO_FORWARD, PUSH, REPLACE } from './actions';
import { GoAction, PushAction, ReplaceAction, RoutingHistoryMiddlewareAction } from './types';

export interface CreateRoutingHistoryMiddlewareProps {
    history: {
        push: (url: string) => void;
        replace: (url: string) => void;
        go: (steps: number) => void;
        goBack: () => void;
        goForward: () => void;
    };
}

export const createRoutingHistoryMiddleware =
    ({ history }: CreateRoutingHistoryMiddlewareProps) =>
    () =>
    (next: () => void) => {
        const routingHandler = createHandler(
            {
                [PUSH]: ({ payload }: PushAction) => {
                    history.push(payload);
                },

                [REPLACE]: ({ payload }: ReplaceAction) => {
                    history.replace(payload);
                },

                [GO]: ({ payload }: GoAction) => {
                    history.go(payload);
                },

                [GO_BACK]: () => {
                    history.goBack();
                },

                [GO_FORWARD]: () => {
                    history.goForward();
                },
            },
            next
        );
        // @ts-expect-error
        return (action: RoutingHistoryMiddlewareAction) => routingHandler(action.type, action);
    };
